import React from 'react';

export default class ToggleableContent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isSelected: this.props.isSelected || false
        };

        this.onToggle = this.onToggle.bind(this);
    }

    onToggle() {
        this.setState(prevState => ({isSelected: !prevState.isSelected}));
        this.props.onToggle();
    }

    render() {
        return (
            <div className="filter-group ">
                <div className="filter-group-header">
                    <label className="checkbox-wrapper">
                        <input type="checkbox" className="checkbox" checked={this.state.isSelected}
                               onChange={this.onToggle}/>
                        {this.props.label}
                    </label>
                </div>
                {this.state.isSelected &&
                <div className="filter-group-content">
                    {this.props.children}
                </div>
                }
            </div>
        )
    }


}